export default __webpack_public_path__ + "static/media/R870_6.31c7ea35.png";